import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SellerAvatarComponent } from './components/seller-avatar/seller-avatar.component';

@NgModule({
  declarations: [
    SellerAvatarComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    SellerAvatarComponent
  ]
})
export class SellerAvatarModule {
}
